<!-- A reusable skeleton loader component -->
<template>
  <div 
    :class="[
      'skeleton-loader',
      `skeleton-loader--${type}`,
      { 'skeleton-loader--animated': animated }
    ]"
    :style="{
      width: width,
      height: height
    }"
  >
    <div class="skeleton-loader__content"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SkeletonLoader',
  props: {
    type: {
      type: String,
      default: 'rectangle',
      validator: (value: string) => ['rectangle', 'circle', 'text'].includes(value)
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '20px'
    },
    animated: {
      type: Boolean,
      default: true
    }
  }
})
</script>

<style lang="scss" scoped>
.skeleton-loader {
  background-color: #f0f0f0;
  position: relative;
  overflow: hidden;

  &--circle {
    border-radius: 50%;
  }

  &--text {
    border-radius: 4px;
  }

  &--rectangle {
    border-radius: 8px;
  }

  &--animated {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.2) 20%,
        rgba(255, 255, 255, 0.5) 60%,
        rgba(255, 255, 255, 0)
      );
      animation: shimmer 2s infinite;
    }
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
